import { AuditStatus } from "@/lib/shopConfigAudit";
import { cn } from "@/lib/utils";
import { STATUS_STYLES } from "./statusStyles";

const LEGEND: { status: AuditStatus; label: string }[] = [
  { status: "missing", label: "Not set" },
  { status: "drift", label: "Drifted from default" },
  { status: "match", label: "Matches" },
];

// Rendered on the dark app shell: slate-300 text, never text-primary.
export const StatusLegend = () => (
  <ul
    aria-label="Status legend"
    className="flex flex-wrap items-center gap-4 text-[13px] text-slate-300"
  >
    {LEGEND.map(({ status, label }) => (
      <li key={status} className="flex items-center gap-1.5">
        <span
          aria-hidden
          className={cn("h-2.5 w-2.5 rounded-full", STATUS_STYLES[status].dot)}
        />
        {label}
      </li>
    ))}
  </ul>
);
